/** The current engine version, checked against each theme's manifest.engineCompatibility. */
export const ENGINE_VERSION = '1.0.0';
